export enum RolesEnum {
  ADMIN = "Admin",
  USER = "User"
}